module.exports = __webpack_public_path__ + "img/header-engagementRingsBestseller@2x.7af069a.webp";